function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, JSON, Number, Object, String, bookmarkId, customAlertModalOpen, open) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const isSavedBookmark = !$attr(`unsaved-changes`) && Number.isInteger(bookmarkId);
    const resultsKeysAndValues = $attr(`results-keys-and-values`);
    return {
      value: (h("div", {
        "class": {
          'mp-report-config': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-report-config-button': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'disabled': !isSavedBookmark,
              'icon': `alert-normal`,
              'theme': `tertiary`,
              'pressed': open,
            }),
            "on": {
              click: $helpers.handleClick
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'max-width': `250px`
            }),
          }, [__vjadeSafeCode($helpers.getTooltipText())]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-report-config-dropdown': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((open) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'open': open
              }),
              "on": {
                change: $helpers.handleMenuChange
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  sections: JSON.stringify([{
                    items: $helpers.getItemsForAlertBell()
                  }])
                }),
                "on": {
                  clickItem: $helpers.handleClickedItemFromAlertBell
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((customAlertModalOpen && ($attr(`display-context`) === `INSIGHTS` || $attr(`display-context`) === `FUNNELS`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": __vjadeStringifyAttrsIfObj({
              open: true,
              closeable: true,
              'grow-to-content': true,
              'hide-close-button': true,
            }),
            "on": {
              change: ({
                detail
              }) => (detail.state === `closed` && $helpers.closeCustomAlertModal()),
            },
          }, (function() {
            var __jade_nodes = [];
            const reportType = $helpers.getReportTypeFromContext();
            const resultsKeysAndValues = $helpers.getResultsKeysAndValues();
            __jade_nodes = __jade_nodes.concat(h("mp-custom-alert-modal", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'bookmark-id': $attr(`bookmark-id`),
                'enable-condition-types': $attr(`enable-custom-alert-condition-types`),
                'is-editing-mode': false,
                'is-percentage-threshold': $helpers.isPercentageThreshold(resultsKeysAndValues),
                'project-id': $attr(`project-id`),
                'report-type': reportType,
                'results-keys-and-values': JSON.stringify(resultsKeysAndValues),
                'time-unit': $attr(`time-unit`),
              }),
              "on": {
                cancel: $helpers.closeCustomAlertModal,
                create: $helpers.handleCustomAlertCreated,
                error: $helpers.handleCustomAlertError,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Number" in locals ? locals.Number : typeof Number !== "undefined" ? Number : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "bookmarkId" in locals ? locals.bookmarkId : typeof bookmarkId !== "undefined" ? bookmarkId : undefined, "customAlertModalOpen" in locals ? locals.customAlertModalOpen : typeof customAlertModalOpen !== "undefined" ? customAlertModalOpen : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;